import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// SERVICES
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class OrderSalesApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getOrderSalesByKit(params :{
    [param :string] :string | string[];
  }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/orders/sales/view-by-kits`,
      {
        params,
      },
    );
  }

  getSalesOrderItemIncomingTransactions(params :{
    rfqId :number;
    relations ?:string;
  }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV1}/sales/shipstation_sales/incoming_transactions`,
      {
        params,
      },
    );
  }

  bulkDeleteOrders(params :{
    salesOrders :{ id :number }[];
    rollbackInventory ?:boolean;
  }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV1}/sales/shipstation_sales/bulk-delete`,
      body: {
        ...params,
      },
    });
  }

  bulkUpdateTags(params :{
    selectedIds :number[];
    tags :number[];
    salesOrderParams ?:{ [param :string] :string | string[] };
    isSelectAllRows ?:boolean;
  }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/orders/sales/bulk-update-tags`,
      body: {
        ...params,
      },
    });
  }

  getAllSelectableRowCount(params :{
    [param :string] :string | string[];
  }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/orders/sales/all-selectable-row-count`,
      {
        params,
      },
    );
  }

  selectAllAction(params :{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/orders/sales/select-all-action`,
      body: { ...params },
    });
  }

  pushFulfillment(salesOrderId :number) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/integration/orders/fulfillment`,
      body: { salesOrderId },
    });
  }

  unpostOrders(params :{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/orders/sales/unpost`, {
      params,
    });
  }

  getComposedItems(params :{
    [param :string] :string | string[];
  }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/orders/sales/items/composed`,
      {
        params,
      },
    );
  }

  pullShipments() :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/orders/sales/pull-shipments`,
    });
  }
}
